import { render } from "./CreateTenantModal.vue?vue&type=template&id=1818d9c7"
import script from "./CreateTenantModal.vue?vue&type=script&lang=js"
export * from "./CreateTenantModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__